import api from '../../../../utils/api';

export interface IncomeSourceFreelanceResponse {
    companyName: string;
    chamberOfCommerceNumber: string | null;
    startDate: string;
    grossIncome: number;
    grossIncomeRemark: string | null;
}

export interface IncomeSourceFreelanceFormData {
    companyName: string;
    chamberOfCommerceNumber: string;
    isCompanyLocatedInTheNetherlands: string;
    startDate: string;
    grossIncome: string;
    grossIncomeRemark: string;
}

const incomeSourceFreelanceToFormData = (response: IncomeSourceFreelanceResponse): IncomeSourceFreelanceFormData => {
    return {
        companyName: response.companyName,
        chamberOfCommerceNumber: response.chamberOfCommerceNumber || '',
        isCompanyLocatedInTheNetherlands: response.chamberOfCommerceNumber ? 'true' : 'false',
        startDate: response.startDate,
        grossIncome: response.grossIncome ? response.grossIncome.toString() : '',
        grossIncomeRemark: response.grossIncomeRemark || '',
    };
}

const findIncomeSourceFreelance = async (sourceId: string): Promise<IncomeSourceFreelanceFormData> => {
    const response: IncomeSourceFreelanceResponse = await api.getWithoutAuth(`api/screening/income-verification/details/freelance`, { sourceId });

    return incomeSourceFreelanceToFormData(response);
}

export default findIncomeSourceFreelance;
